module.exports = __webpack_public_path__ + "b27a4486c1eeaffa1a5c8d1851483d53.png";